const uploadAccept = "image/*,.heic,.psd,.heif";
export default uploadAccept;
